module.exports = __webpack_public_path__ + "components/rewards/hourly/static/logo-b9cffc95949ab423eabbbd10f58e943b.webp";